import $ from 'jquery';
import stickybits from 'stickybits';


$(function () {


	/* Mobile nav
	********************************************/

	var backLabel = $('ul.mobile-nav').data('back');

	$('a.menu-toggle, a.js-mobile-menu-toggle').on('click', function(e){
		e.preventDefault();
		$('a.menu-toggle').toggleClass('open');
		$('html').toggleClass('mobile-navigation-opened');
		$('.mobile-menu-wrapper').toggleClass('show');
	});

	$('ul.mobile-nav li.menu-item-has-children > a').on('click', function(e){
		e.stopImmediatePropagation();
		e.preventDefault();
		var $this = $(this);
		var parentTitle = $this.text();
		var parentIcon = $this.parent().attr('data-icon');
		var $subMenu = $this.siblings('ul.sub-menu');
		var check_icon = parentIcon ? parentIcon.split(" ") : "";
		var no_icon = $.inArray( 'no-icon', check_icon );
		if(!($subMenu).hasClass('generated')){
			var hasIcon = '';
			if(typeof parentIcon !== 'undefined'){ var hasIcon = ' has-icon'}
			if(parentTitle){
				if( no_icon == 1 ){
					$this.siblings('ul.sub-menu').prepend('<li class="back"><a href="#">'+backLabel+'</a></li><li class="title"><span>'+parentTitle+'</span></li>');
				}else{
					$this.siblings('ul.sub-menu').prepend('<li class="back"><a href="#">'+backLabel+'</a></li><li class="title'+hasIcon+'"><span><i class="'+parentIcon+'"></i>'+parentTitle+'</span></li>');
				}
			}else{
				$this.siblings('ul.sub-menu').prepend('<li class="back"><a href="#">'+backLabel+'</a></li>');
			}
		}
		$this.siblings('ul.sub-menu').addClass('show generated');
		$this.closest('ul.sub-menu').addClass('push-back');
		$this.closest('ul.mobile-nav').addClass('push-back');
	});

	$('body').on('click', 'li.back > a', function(e){
		e.preventDefault();
		$(this).closest('ul.sub-menu').removeClass('show');
		$(this).closest('ul.sub-menu.push-back').removeClass('push-back');
		$(this).closest('ul.mobile-nav.push-back').removeClass('push-back');
	});


	/* Menu equal height
	********************************************/

	function equalize( selector ) {
		const $parents = $( selector );
		if ( ! $parents.length ) {
			return;
		}
		$parents.each( function () {
			let maxHeight = 0;
			$( this ).children().each( function () {
				if ( $( this ).outerHeight() > maxHeight ) {
					maxHeight = $( this ).outerHeight();
				}
			} );
			$( this ).children().css( 'min-height', maxHeight );
		} );
	};
	equalize( '.has-equal-height-children' );


	/* Search
	********************************************/

	$('ul.main-menu li.search a.search-button').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('active');
		$('.site-header .main-nav').toggleClass('search-active');
		$('li.search input').trigger('focus');
	});

	$('ul.main-menu li.search a.close-search').on('click', function(e){
		e.preventDefault();
		$(this).siblings('a.search-button').toggleClass('active');
		$('.site-header .main-nav').toggleClass('search-active');
	});


	/* Sticky
	********************************************/

	if ($('.js-sticky-mobile-header').length) {
		if ($(window).width() < 769) {
			var lastScroll = 0;
			setTimeout(function waitUntilDomIsReadyLoadingCustomFontsMightOffsetThis() {
				$(window).on('scroll',function() {
					var scroll = $(window).scrollTop();
					if(lastScroll - scroll > 0) {
						$('.js-sticky-mobile-header').addClass('js-sticky-show-toggle');
					} else {
						$('.js-sticky-mobile-header').removeClass('js-sticky-show-toggle');
					}
					lastScroll = scroll;
				});
			}, 1000);
		}
	}

/*
	var logoHeight = $('#site-header .site-title').outerHeight(true);

	if ($(window).width() < 769) {
		stickybits('#site-header', {
			useStickyClasses: true,
			//useFixed: true,
			//stickyBitStickyOffset: - pageHeaderHeight - 20,
			//customStickyChangeNumber: 10
		});
	} else {
		stickybits('#site-header', {
			useStickyClasses: true,
			//useFixed: true,
			stickyBitStickyOffset: - logoHeight - 1,
			//customStickyChangeNumber: 10
		});
	}
*/


});
